import React from 'react';
import cx from 'classnames';

import { CARD_OVERLAY_BUTTON } from '../../styles/card';
import Text from '../../../../../Text';






const OverlayButton = ({ action, name }) =>
<button
  className={cx('card-overlay__button', CARD_OVERLAY_BUTTON)}
  type="button"
  onClick={action}>

    <Text button darkTheme>{name}</Text>
  </button>;


export default OverlayButton;